/**
 * The server's refusal to change a booking the clinic's booking system owns
 * (CLA-1695): 409 `{error: "managed_in_timely", detail: "<sentence>"}`, for a
 * move, re-time, cancel, booked/confirmed/cancelled status or practitioner or
 * room change on a synced booking. The UI hides those controls; this is for
 * the request that still gets through (an old cache, a sync that landed while
 * the booking was open). See `components/calendar/managedBooking.ts`.
 */
import { ApiError } from './client'

export function isManagedRefusal(err: unknown): boolean {
  return (
    err instanceof ApiError &&
    err.status === 409 &&
    (err.body as { error?: unknown } | undefined)?.error === 'managed_in_timely'
  )
}

/** The server's own sentence, or null when it sent none. */
export function managedRefusalDetail(err: unknown): string | null {
  if (!isManagedRefusal(err)) return null
  const detail = ((err as ApiError).body as { detail?: unknown } | undefined)?.detail
  return typeof detail === 'string' && detail.trim() ? detail : null
}
